/**
 * Status wydatku jest pochodną pieniędzy, nie przyciskiem — backend wylicza go
 * z zapłat i nie da się go ustawić ręcznie.
 */
export enum ExpensePaymentStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  CANCELLED = 'CANCELLED',
}
